import React from "react";
import { Link } from "react-router-dom";
import { Phone, ShieldCheck, ArrowRight, CalendarCheck } from "lucide-react";
import { company, heroImage, stats, isDoddActive } from "../mock";
import { Button } from "./ui/button";

const Hero = () => {
  return (
    <section className="relative overflow-hidden bg-white">
      <div className="hero-blob h-72 w-72 bg-[#2E9E6A] -top-10 -left-10" />
      <div className="hero-blob h-80 w-80 bg-[#1B7A98] top-40 right-0" />

      <div className="relative mx-auto max-w-7xl px-4 pt-16 pb-20 grid lg:grid-cols-2 gap-12 items-center">
        <div className="fade-up">
          <div data-testid="hero-dodd-banner" className="inline-flex items-center gap-2 rounded-full bg-[#E9F6EF] text-[#23875A] px-4 py-1.5 text-sm font-semibold mb-6">
            <ShieldCheck className="h-4 w-4 shrink-0" />
            NOW ACCEPTING NEW CLIENTS — MyCare Ohio & DODD
          </div>
          <h1 data-testid="hero-h1" className="font-display font-extrabold text-4xl md:text-5xl xl:text-6xl leading-tight text-[#0E2A33]">
            Ohio Home Care &amp; <span className="text-[#0E5A72]">DODD Provider</span>
          </h1>
          <p className="mt-4 text-xl font-semibold text-[#0E5A72]">
            Person-centered home care for individuals, families, County Boards, referral professionals, and private-pay clients across Ohio.
          </p>
          {!isDoddActive() && (
            <p className="mt-3 text-slate-600 flex items-center gap-2">
              <CalendarCheck className="h-4 w-4 text-[#2E9E6A] shrink-0" />
              Now accepting new patients and referrals — MyCare Ohio, DODD, PASSPORT and private pay.
            </p>
          )}

          <div className="mt-8 flex flex-wrap gap-3">
            <Link to="/refer">
              <Button data-testid="hero-refer-btn" className="bg-[#0E5A72] hover:bg-[#0A4557] text-white rounded-full h-12 px-6 text-base font-semibold">
                REFER A CLIENT <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
            </Link>
            <Link to="/contact">
              <Button data-testid="hero-request-btn" className="bg-[#2E9E6A] hover:bg-[#23875A] text-white rounded-full h-12 px-6 text-base font-semibold">
                REQUEST HOME CARE
              </Button>
            </Link>
            <Link to="/family-caregiver">
              <Button data-testid="hero-fc-btn" variant="outline" className="rounded-full h-12 px-6 text-base border-[#0E5A72] text-[#0E5A72] hover:bg-[#EAF4F7] font-semibold">
                I ALREADY HAVE A CAREGIVER
              </Button>
            </Link>
            <Link to="/careers">
              <Button data-testid="hero-careers-btn" variant="outline" className="rounded-full h-12 px-6 text-base border-slate-300 text-slate-700 hover:bg-slate-50 font-semibold">
                JOIN OUR CARE TEAM
              </Button>
            </Link>
          </div>

          <a href={`tel:${company.phoneRaw}`} className="mt-6 inline-flex items-center gap-2 text-[#0E5A72] font-semibold hover:underline">
            <Phone className="h-4 w-4" /> {company.phone}
          </a>
        </div>

        <div className="relative fade-up">
          <div className="absolute -inset-4 brand-gradient-soft rounded-[2rem] rotate-3" />
          <img
            src={heroImage}
            alt="Caregiver smiling with an elderly client at home"
            className="relative rounded-[2rem] shadow-2xl object-cover w-full h-[420px] md:h-[500px]"
            fetchPriority="high"
          />
          <div className="absolute -bottom-6 left-6 bg-white rounded-2xl shadow-xl p-4 flex items-center gap-3">
            <div className="brand-gradient h-11 w-11 rounded-xl grid place-items-center text-white">
              <ShieldCheck className="h-6 w-6" />
            </div>
            <div>
              <div className="font-display font-bold text-[#0E5A72]">DODD Certified Provider</div>
              <div className="text-xs text-slate-500">Background-checked caregivers</div>
            </div>
          </div>
        </div>
      </div>

      <div className="relative border-t border-slate-100 bg-[#F7FBFC]">
        <div className="mx-auto max-w-7xl px-4 py-8 grid grid-cols-2 md:grid-cols-4 gap-6">
          {stats.map((s) => (
            <div key={s.label} className="text-center">
              <div className="font-display font-extrabold text-3xl text-[#0E5A72]">{s.value}</div>
              <div className="text-sm text-slate-500 mt-1">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;
